import { useMemo } from 'react'

//* Style
import MapStyle from './style'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import Image from 'components/common/Image'

const Map = ({ title, points, image, first }) => {
	//! Points
	const storePoints = useMemo(() => {
		return points.map((item, index) => {
			return (
				<div className='point-wrap' key={index}>
					<Text className={'font-soundscape-bold primaryColor1 point-number'}>{`${index + 1}`.padStart(1, 0) + '.'}</Text>
					<Text className={'font-ping-medium primaryColor1 point'}>{`${item.title}`}</Text>
				</div>
			)
		})
	}, [points])

	return (
		<Container section full first={first}>
			<MapStyle>
				<Container row>
					<div className={'col-5 col-t-6 col-ts-12'}>
						<Text className={'h3 font-ping-bold title primaryColor1'}>{title}</Text>
						<div className={'points-container'}>{storePoints}</div>
					</div>
					<div className='col-1 col-t-12 offset' />
					<div className='col-6 col-t-6 col-ts-12'>
						<Image className={'map-image'} src={image.url} alt={image.alt} />
					</div>
				</Container>
			</MapStyle>
		</Container>
	)
}

export default Map
